import React, { useState, useEffect, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { withStyles, makeStyles } from '@mui/styles';
import LoginMenu from '../../../../../components/LoginMenu/LoginMenu';
import { numberFreeExp } from '../../../../../utils/regularExpression';
import { TextField, Grid, Button, CircularProgress, Snackbar, Divider, Typography, Radio } from '@mui/material';
import BottomBar from "../../../../../components/BottomBar/BottomBar";
import CustomizedSnackbar from "../../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import MenuItem from "@mui/material/MenuItem";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import { id } from 'date-fns/locale';
import { keys } from '@mui/material/styles';
import { grey } from '@mui/material/colors';


const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
    },
    formControl: {
        minWidth: '100%',
    },
    sectionTitle: {
        fontSize: 19,
        color: '#174a84',
    },
    checkboxDividerLabel: {
        marginTop: 10,
        marginLeft: 5,
        marginRight: 20,
        fontSize: 16,
        fontWeight: 600
    },
    rootProgress: {
        width: '100%',
        textAlign: 'center',
    },
}));
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(29, 95, 152)",
        color: theme.palette.common.white,
        fontWeight: 500,
        border: '1px solid white'
    },
    body: {
        fontSize: 14,
        border: '1px solid rgb(29, 95, 152)'
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const CourseRow = (props) => {


    const { dataLabel, dataIndex, dataId, feedbackAnswerId } = props;
    const [selectedValue, setSelectedValue] = React.useState("");


    const handleChange = (event) => {
        console.log(event.target.value);
        setSelectedValue(event.target.value);
    };


    // const myFun = (e) => {
    //     alert(e.target.value);

    // }

    return (
        <Fragment>
            <StyledTableRow >
                <StyledTableCell component="th" scope="row">
                    {dataLabel}
                    <input
                        type="hidden"
                        name="feedbackQuestionId"
                        value={dataId} />

                </StyledTableCell>

                <input
                    type="hidden"
                    name="feedbackAnswersId"
                    value={selectedValue} />
                {dataId == 13 ?
                    <React.Fragment>
                        <StyledTableCell
                            style={{}}
                        >  <p style={{ display: "inline", marginLeft: 50 }}>Yes</p>
                            <Radio

                                required={true}
                                checked={selectedValue == 1}
                                color="primary"
                                onChange={handleChange}
                                value={1}
                                size="small"
                            />
                        </StyledTableCell>
                        <StyledTableCell
                            style={{ textAlign: 'center' }}
                        >
                            <p style={{ display: "inline" }}>No</p>
                            <Radio
                                style={{
                                    marginRight: 20
                                }}

                                required={true}
                                checked={selectedValue == 2}
                                color="primary"
                                onChange={handleChange}
                                value={2}
                                defaultValue={0}
                                size="small"
                            />

                        </StyledTableCell>
                        <StyledTableCell
                            style={{ textAlign: 'center' }}
                        >
                        </StyledTableCell>
                        <StyledTableCell
                            style={{ textAlign: 'center' }}
                        >
                        </StyledTableCell>
                        <StyledTableCell
                            style={{ textAlign: 'center', backgroundColor: 900 }}
                        >
                        </StyledTableCell>
                    </React.Fragment>
                    :
                    feedbackAnswerId.map((item) => (
                        <StyledTableCell
                            style={{
                                textAlign: 'center'
                            }}
                            key={"Answer" + dataLabel + item.id}
                            label="feedbackAnswerId"
                        >
                            <Radio
                                required={true}
                                checked={selectedValue == item.id}
                                color="primary"
                                onChange={handleChange}
                                value={item.id}
                                inputProps={{ 'aria-label': dataLabel + item.id }}
                                size="small"
                            />
                        </StyledTableCell>
                    ))
                }

            </StyledTableRow>
        </Fragment>

    );
}




const F115Form = (props) => {
    const classes = useStyles();
    const { recordId: recordIdParam, dataId, dataLabel } = useParams();
    const [recordId, setRecordId] = useState(recordIdParam);
    const [isLoading, setIsLoading] = useState(false);
    const [isReload, setIsReload] = useState(false);
    const [label, setLabel] = useState("");
    const [labelError, setLabelError] = useState("");
    const [shortLabel, setShortLabel] = useState("");
    const [shortLabelError, setShortLabelError] = useState("");
    const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("");
    const [rowData, setRowData] = useState([""]);
    const [feedBackMenuItems, setFeedBackMenuItems] = useState([]);
    const [feedBackId, setFeedBackId] = useState("");
    const [feedBackIdError, setFeedBackIdError] = useState("");
    const [feedBackCourse, setFeedBackCourse] = useState([]);
    const [courseId, setCourseId] = useState("");
    const [courseIdError, setCourseIdError] = useState("");
    const [feedBackTeacher, setFeedBackTeacher] = useState([]);
    const [teacherId, setTeacherId] = useState("");
    const [teacherIdError, setTeacherIdError] = useState("");
    const [feedbackAnswerId, setFeedbackAnswerId] = useState([{ "id": 1, "label": "Poor" }, { "id": 2, "label": "Fair" }, { "id": 3, "label": "Good" }, { "id": 4, "label": "V. Good" }, { "id": 5, "label": "Excellent" }]);
    const [sessionLabel, setSessionLabel] = useState("");
    const [feedBackCourseOne, setFeedBackCourseOne] = useState("");
    const [isLoginMenu, setIsLoginMenu] = useState(false);

    const handleOpenSnackbar = (msg, severity) => {
        setIsOpenSnackbar(true);
        setSnackbarMessage(msg);
        setSnackbarSeverity(severity);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setIsOpenSnackbar(false);
    };

    const loadFeedBack = async (index) => {
        const data = new FormData();
        data.append("id", index);
        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C115CommonStudentsFeedbackQuestionsView`;
        await fetch(url, {
            method: "POST",
            body: data,
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("lmsToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    if (json.CODE === 1) {
                        let feedBackMenuItems = json.DATA || [];
                        setFeedBackMenuItems(feedBackMenuItems);
                        console.log(feedBackMenuItems);
                    } else {
                        //alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE);
                        handleOpenSnackbar(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE, "error");
                    }
                    console.log(json);
                },
                error => {
                    if (error.status == 401) {
                        setIsLoginMenu(true);
                        setIsReload(false);
                    } else {
                        console.log(error);
                        // alert("Failed to Save ! Please try Again later.");
                        handleOpenSnackbar("Failed to Save! Please Fill All The Answers.", "error");
                    }
                });
        setIsLoading(false);
    };



    const loadSession = async (index) => {
        const data = new FormData();
        data.append("id", index);
        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C115CommonAcademicsCurrentSessionView`;
        await fetch(url, {
            method: "POST",
            body: data,
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("lmsToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    if (json.CODE === 1) {
                        let sessionLabel = json.DATA[0].sessionLabel || "";
                        setSessionLabel(sessionLabel);
                        console.log(sessionLabel);
                    } else {
                        //alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE);
                        handleOpenSnackbar(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE, "error");
                    }
                    console.log(json);
                },
                error => {
                    if (error.status == 401) {
                        setIsLoginMenu(true);
                        setIsReload(false);
                    } else {
                        console.log(error);
                        // alert("Failed to Save ! Please try Again later.");
                        handleOpenSnackbar("Failed to Save! Please Fill All The Answers.", "error");
                    }
                });
        setIsLoading(false);
    };


    // loadAnswers = async(index) => {
    //     const data = new FormData();
    //     data.append("id",index);
    //     this.setState({isLoading: true});
    //     const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C115CommonStudentsFeedbackQuestionsAnswersSave`;
    //     await fetch(url, {
    //         method: "POST",
    //         body: data,
    //         headers: new Headers({
    //             Authorization: "Bearer "+ localStorage.getItem("lmsToken")
    //         })
    //     })
    //         .then(res => {
    //             if (!res.ok) {
    //                 throw res;
    //             }
    //             return res.json();
    //         })
    //         .then(
    //             json => {
    //                 if (json.CODE === 1) {
    //                     let feedbackAnswerId = json.DATA || [];
    //                     this.setState({feedbackAnswerId:feedbackAnswerId});
    //                     console.log(feedbackAnswerId);
    //                     // if(feedbackAnswerId.length!=13){
    //                     //     this.handleOpenSnackbar("Please Answer");
    //                     // }
    //                 } else {
    //                     //alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE);
    //                     this.handleOpenSnackbar(json.SYSTEM_MESSAGE+'\n'+json.USER_MESSAGE,"error");
    //                 }
    //                 console.log(json);
    //             },
    //             error => {
    //                 if (error.status == 401) {
    //                     this.setState({
    //                         isLoginMenu: true,
    //                         isReload: false
    //                     })
    //                 } else {
    //                     console.log(error);
    //                    // alert("Failed to Save ! Please try Again later.");
    //                     this.handleOpenSnackbar("Failed to Save! Please Fill All The Answers.","error");
    //                 }
    //             });
    //     this.setState({isLoading: false})
    // }

    const loadCourse = async (index) => {
        const data = new FormData();
        data.append("id", index);
        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C115CommonAcademicsCoursesStudentsView`;
        await fetch(url, {
            method: "POST",
            body: data,
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("lmsToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    if (json.CODE === 1) {
                        let feedBackCourse = json.DATA || [];
                        setFeedBackCourse(feedBackCourse);
                        if (feedBackCourse.length) {
                            setCourseId(feedBackCourse[0].id);
                            loadTeachers(feedBackCourse[0].id);
                            console.log(feedBackCourse);
                        }
                        else {
                            handleOpenSnackbar("Feedback already Completed.", "error");
                        }

                    } else {
                        //alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE);
                        handleOpenSnackbar(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE, "error");
                    }
                    console.log(json);
                },
                error => {
                    if (error.status == 401) {
                        setIsLoginMenu(true);
                        setIsReload(false);
                    } else {
                        console.log(error);
                        // alert("Failed to Save ! Please try Again later.");
                        handleOpenSnackbar("Failed to Save! Please Fill All The Answers.", "error");
                    }
                });
        setIsLoading(false);
    };


    const loadTeachers = async (courseId) => {
        const data = new FormData();
        data.append("courseId", courseId);
        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C115CommonAcademicsCoursesTeachersView`;
        await fetch(url, {
            method: "POST",
            body: data,
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("lmsToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    if (json.CODE === 1) {
                        let feedBackTeacher = json.DATA || [];
                        setFeedBackTeacher(feedBackTeacher);
                        if (feedBackTeacher.length) {
                            setTeacherId(feedBackTeacher[0].id);
                        }
                        console.log(feedBackTeacher);
                    } else {
                        //alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE);
                        handleOpenSnackbar(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE, "error");
                    }
                    console.log(json);
                },
                error => {
                    if (error.status == 401) {
                        setIsLoginMenu(true);
                        setIsReload(false);
                    } else {
                        console.log(error);
                        // alert("Failed to Save ! Please try Again later.");
                        handleOpenSnackbar("Failed to Save! Please Fill All The Answers.", "error");
                    }
                });
        setIsLoading(false);
    };

    const islabelValid = () => {
        let isValid = true;
        if (!label) {
            setLabelError("Please enter School Name.");
            document.getElementById("label").focus();
            isValid = false;
        } else {
            setLabelError("");
        }
        return isValid;
    };

    const isshortLabelValid = () => {
        let isValid = true;
        if (!shortLabel) {
            setShortLabelError("Please enter Short Name.");
            document.getElementById("shortLabel").focus();
            isValid = false;
        } else {
            setShortLabelError("");
        }
        return isValid;
    };

    const onHandleChange = e => {
        const { name, value } = e.target;

        let regex = "";
        switch (name) {
            case "courseId":
                loadTeachers(value);
                setCourseId(value);
                setCourseIdError("");
                break;
            default:
                break;
        }
    };

    const clickOnFormSubmit = () => {
        onFormSubmit();
    };

    const onFormSubmit = async (e) => {
        // e.preventDefault();
        // if(
        //     !islabelValid() ||
        //     !isshortLabelValid()
        // ){ return; }

        let myForm = document.getElementById('myForm');
        const data = new FormData(myForm);
        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C115CommonStudentsFeedbackQuestionsAnswersSave`;
        await fetch(url, {
            method: "POST",
            body: data,
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("lmsToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    if (json.CODE === 1) {
                        //alert(json.USER_MESSAGE);
                        handleOpenSnackbar(json.USER_MESSAGE, "success");
                        setTimeout(() => {
                            if (dataId != 0 && dataLabel != 0) {
                                window.location = "#/dashboard/F115Form/0";
                                window.location.reload();
                            } else {
                                window.location.reload();
                            }
                        }, 2000);
                    } else {
                        //alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE)
                        // handleOpenSnackbar(json.SYSTEM_MESSAGE+'\n'+json.USER_MESSAGE,"error");
                        handleOpenSnackbar("Failed to Save! Please Fill All The Answers.", "error");
                    }
                    console.log(json);
                },
                error => {
                    if (error.status == 401) {
                        setIsLoginMenu(true);
                        setIsReload(false);
                    } else {
                        console.log(error);
                        //alert("Failed to Save ! Please try Again later.");
                        handleOpenSnackbar("Failed to Save ! Please Select All The Answers.", "error");
                    }
                });
        setIsLoading(false);
    };


    // const viewReport = () => {
    //     window.location = "#/dashboard/F06Reports";
    // };

    useEffect(() => {
        props.setDrawerOpen(false);
        loadFeedBack();
        loadCourse();
        loadSession();
    }, []);

    useEffect(() => {
        if (dataId) {
            if (dataId != 0) {
                props.setDrawerOpen(false);
                loadFeedBack();
            } else {
                window.location.reload();
            }
        }
    }, [dataId]);

    const lmsData = localStorage.getItem("lmsData") ? JSON.parse(localStorage.getItem("lmsData")) : {};

    return (
        <Fragment>
            <LoginMenu reload={isReload} open={isLoginMenu} handleClose={() => setIsLoginMenu(false)} />
            <form id="myForm" name="myForm" required>
                {/* <TextField type="hidden" name="recordId" value={id}/> */}
                <Grid container component="main" className={classes.root}>
                    <Typography
                        style={{
                            color: '#1d5f98',
                            fontWeight: 600,
                            // borderBottom: '1px solid #d2d2d2',
                            marginBottom: 2,
                            width: '98%',
                            fontSize: 20
                        }}
                        variant="h5"
                    >
                        <h2 style={{ textAlign: "center" }}>Teacher Feedback ({sessionLabel})</h2>


                    </Typography>
                    <Divider style={{
                        backgroundColor: 'rgb(58, 127, 187)',
                        opacity: '0.3'
                    }}
                    />
                    <Grid
                        container
                        spacing={0}
                        style={{
                            marginLeft: 5,
                            marginRight: 10
                        }}
                    >
                        <Grid size={12}>
                            <Grid item xs={6}
                            >
                                <Typography
                                    required={true}
                                    style={
                                        {
                                            marginBottom: 10
                                        }
                                    }
                                ><h4
                                    style={{
                                        display: "inline",
                                        color: '#1d5f98',

                                    }}
                                >Student Name: </h4>
                                    <p style={{ marginLeft: 5, display: "inline", color: '#1d5f98' }}>{lmsData.displayName}</p>

                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={6}
                            >
                                <Typography
                                    style={{
                                        marginBottom: 10
                                    }}
                                    required={true}
                                    id="teacherId"
                                    name="teacherId"
                                >
                                    <h4 style={{ display: "inline", color: '#1d5f98', }}>Teacher Name:</h4>
                                    {feedBackTeacher.map((item) => (

                                        <p
                                            style={{
                                                marginLeft: 5,
                                                display: "inline",
                                                color: '#1d5f98'
                                            }}
                                            key={"Teacher" + item.id} value={item.id}>
                                            <input type="hidden" name="teacherId" value={item.id} />
                                            {item.label}
                                        </p>

                                    ))}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid
                            item xs={6}
                        >
                            <TextField
                                style={{
                                    width: '98%',
                                    marginBottom: 10,
                                }}

                                required={true}
                                id="courseId"
                                name="courseId"
                                label="Subject"
                                fullWidth
                                variant="outlined"
                                onChange={onHandleChange}
                                value={courseId}
                                error={courseIdError}
                                select
                            >
                                {feedBackCourse.map((item) => (
                                    <MenuItem key={"course" + item.id} value={item.id} name="MenuLabel"  >
                                        {item.courseLabel}
                                    </MenuItem>
                                ))}
                            </TextField>

                        </Grid>

                        <Grid size={12}>


                            <TableContainer component={Paper}>
                                <Table size="small" aria-label="customized table">
                                    <TableHead>
                                        <TableRow>

                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell align="center">Poor (1)</StyledTableCell>
                                            <StyledTableCell align="center">Fair (2)</StyledTableCell>
                                            <StyledTableCell align="center">Good (3)</StyledTableCell>
                                            <StyledTableCell align="center">V. Good (4)</StyledTableCell>
                                            <StyledTableCell align="center">Excellent (5)</StyledTableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {feedBackMenuItems.map((rowData, index) => (
                                            <CourseRow
                                                key={"index" + index}
                                                dataId={rowData.id}
                                                dataLabel={rowData.label}
                                                dataIndex={index}
                                                feedbackAnswerId={feedbackAnswerId}


                                            />
                                        ))}





                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Grid>
                        <Grid
                            item
                            xs={12}
                            style={{
                                paddingBottom: 20,
                                paddingTop: 20,
                                display: 'flex'
                            }}
                        >

                            <TextField
                                style={{
                                    width: '100%',
                                    marginBottom: 30,
                                }}
                                name="comments"
                                label="Your Comments"
                                required
                                fullWidth
                                variant="outlined"
                            ></TextField>
                        </Grid>
                    </Grid>
                </Grid>

            </form>
            <BottomBar
                left_button_text="View"
                leftButtonHide={true}
                right_button_text="Save"
                rightButtonDisable={courseId.length == 0}
                rightButtonAction={onFormSubmit}
                loading={isLoading}
                isDrawerOpen={props.isDrawerOpen}
            />
            <CustomizedSnackbar
                isOpen={isOpenSnackbar}
                message={snackbarMessage}
                severity={snackbarSeverity}
                handleCloseSnackbar={() => handleCloseSnackbar()}
            />
        </Fragment>
    );
};

export default F115Form;
